import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Banner from 'components/Banner';
import {
    fetchDetailTrialResults,
    selectDetailTrialResults,
    fetchTrialResultsPageList,
    selectTrialResultsPageList,
} from 'store/slices/TrialResults';
import WithSidebar from 'Layout/WithSidebar';
import PDFBox from 'components/PDFBox';
import ProductSidebar from 'components/ProductSidebar';
import { ROUTES } from 'constants/routes';
// {
//     "status": "success",
//     "data": {
//       "slug": "cabbage",
//       "title": "Cabbage",
//       "icon": "http://54.93.104.183/storage/crops/iN2BNsy7dsCnU2CGTLFF0uDv0gjCP92fUtSYPkGt.png",
//       "fs_background": "http://54.93.104.183/storage/brunoMartins.jpg",
//       "fs_view_button": "View button",
//       "sidebar_text": "Sidebar text",
//       "show_more": "Show more text",
//       "trials": []
//     }
//   }
// TODO NOT DONE!
const DetailedTrialResults = () => {
    const dispatch = useDispatch();
    const { slug } = useParams();

    const data = useSelector(selectDetailTrialResults);
    const crops = useSelector(selectTrialResultsPageList);
    const sidebarCrops = crops.filter(item => item.slug !== slug);

    const { title, fs_background, fs_view_button, sidebar_text, trials } = data;

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchTrialResultsPageList({ all: true }));
        // @ts-ignore
        dispatch(fetchDetailTrialResults({ slug }));
    }, [dispatch, slug]);

    return (
        <>
            <Banner title={title} image={fs_background} buttonText={fs_view_button} />
            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={<ProductSidebar title="!!!" data={sidebarCrops} baseRoute={ROUTES.trialResults} />}
                >
                    <PDFBox data={trials} />
                </WithSidebar>
            </section>
        </>
    );
};

export default DetailedTrialResults;
